

    'use strict';

    const $ = require('jquery');



    const Ajax = {
            aData: window.oData,
            sUrl: '',
            sMethod: '',

            send: function ($this) {

                return this.promise($this);
            },

            promise: function ($this) {

                return new Promise(function (resolve, reject) {
                    $.ajax
                    ({
                        url: $this.sUrl,
                        method: $this.sMethod,
                        dataType: 'json',
                        data: $this.aData,

                        success: function (oResponse) {
                            const token = window.oData.csrf_baptist;
                            window.oData = {};
                            window.oData.csrf_baptist = token;

                            if (
                                oResponse.header &&
                                oResponse.header.code &&
                                oResponse.header.code != 200 ) {
                                reject(oResponse.data);
                            } else {
                                resolve(oResponse.data);
                            }
                        },
                        error: function (oResponse) {
                            reject(oResponse.responseJSON.data);
                        }
                    });
                });
            }
        };

    module.exports = Ajax;
